import { defineMessages } from 'react-intl';

export const shipFromContextMessages = defineMessages({
  ltlDefaultsPartialSaveWarning: {
    id: 'R24L/e',
    description:
      'Warning notification shown when the main ship-from location saved successfully but the freight defaults sub-request failed. Prompts the user to re-enter the freight defaults.',
    defaultMessage:
      'Your location was saved, but freight defaults could not be saved. Please open the location and update Freight Defaults again.',
  },
});
